import type { MessageDescriptor } from 'react-intl';
import type { StudentType } from '@/types/students';

export const STUDENT_COLLECTION_TYPES = [
  'school-transportation',
  'school-student-travel',
  'school-child-and-youth',
] as const;

export type StudentCollectionType = (typeof STUDENT_COLLECTION_TYPES)[number];

export const isStudentCollectionType = (
  type: string,
): type is StudentCollectionType => {
  return (STUDENT_COLLECTION_TYPES as readonly string[]).includes(type);
};

const COLLECTION_TYPE_TO_STUDENT_TYPE: Record<
  StudentCollectionType,
  StudentType
> = {
  'school-transportation': 'transportation',
  'school-student-travel': 'travels',
  'school-child-and-youth': 'child-and-youth',
};

export const collectionTypeToStudentType = (
  collectionType: StudentCollectionType,
): StudentType => {
  return COLLECTION_TYPE_TO_STUDENT_TYPE[collectionType];
};

export const COLLECTION_TYPE_LABELS: Record<
  StudentCollectionType,
  MessageDescriptor
> = {
  'school-transportation': {
    id: 'page.students.transportation.title',
    defaultMessage: 'Skolskjuts',
  },
  'school-student-travel': {
    id: 'page.students.travels.title',
    defaultMessage: 'Elevresor',
  },
  'school-child-and-youth': {
    id: 'page.students.child-and-youth.title',
    defaultMessage: 'Barn- & Ungdomskort',
  },
};

const STUDENT_TYPE_TO_COLLECTION_TYPE: Record<
  StudentType,
  StudentCollectionType
> = {
  transportation: 'school-transportation',
  travels: 'school-student-travel',
  'child-and-youth': 'school-child-and-youth',
};

export const studentTypeToCollectionType = (
  studentType: StudentType,
): StudentCollectionType => {
  return STUDENT_TYPE_TO_COLLECTION_TYPE[studentType];
};

export const STUDENT_TYPE_VIEW: Record<StudentType, string> = {
  travels: 'student-travels',
  transportation: 'student-transportation',
  'child-and-youth': 'student-child-and-youth',
};

export const STUDENT_TYPE_ROUTE = {
  travels: '/$tenantId/students/travels',
  transportation: '/$tenantId/students/transportation',
  'child-and-youth': '/$tenantId/students/child-and-youth',
} as const;

export const STUDENT_TYPE_VIEW_ROUTE = {
  travels: '/$tenantId/students/travels/$view',
  transportation: '/$tenantId/students/transportation/$view',
  'child-and-youth': '/$tenantId/students/child-and-youth/$view',
} as const;
